import { Component, OnInit } from '@angular/core';
import io, { Socket } from 'socket.io-client';
import { GlobalConstants } from './services/global-constants';
import { OrgUnitsService } from './services/org-units.service';
import { NotificationHandlerService } from './services/notification-handler.service';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { NavigationStart, Router } from '@angular/router';
import { CoordinatorRedirectService } from './services/coordinator-redirect.service';
import { PermissionHandlerService } from './services/permission-handler.service';
import { NavigationOriginService } from './services/navigation-origin.service';
import configObj from './misc/data/arabic-ng.json'
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Knowledge Gate';
  socket!: Socket;
  numberOfOnlineUsers: number = 0;
  socketID: string = '';

  constructor(
    private orgUnitService: OrgUnitsService,
    private notificationService: NotificationHandlerService,
    private messageService: MessageService,
    private CoordinatorRedirectService:CoordinatorRedirectService,
    private router: Router,
    private config: PrimeNGConfig,
    private permissionHandler: PermissionHandlerService,
    // Injected so it starts tracking navigation from app startup (it remembers
    // the previous route for the training-page origin-aware breadcrumb).
    private navigationOriginService: NavigationOriginService,
    private themeService: ThemeService,
  ) {


    this.config.setTranslation(configObj);

  }


  ngOnInit(): void {
    // const tag = document.createElement('script');
    // tag.src = '../iframe_api.js';
    // tag.crossOrigin = '*'
    // document.body.appendChild(tag);
    // For everyone, signed in or not: the saved default, then the user's own
    // theme over it. See ThemeService.
    this.themeService.init();
    if (localStorage.getItem('isLoggedIn') == 'true') {
      void (async () => {
        await this.permissionHandler.syncNotificationOusFromServer();
        this.onlineStatus();
      })();
    }
  }

  onlineStatus() {
    const username = localStorage.getItem('username');
    let uid = localStorage.getItem('uid')
    this.socket = io(`${GlobalConstants.socketURL}`)
    // this.socket.on('connect', () => {
    //   this.socket.emit('user_connected', { name: username, uid: uid });
    // })

    // this.socket.on('updateUserStatus', function (data: any) {
    // });

    this.socket.on('notification', (notificaiton) => {
      if (uid == null || uid == undefined) {
        uid = localStorage.getItem('uid');
      }
      if (notificaiton.sender._id != uid && this.notificationService.applyPermissions(notificaiton)) {
        notificaiton = this.notificationService.setNotificationTypeMessage(notificaiton);
        this.notificationService.addNotification(notificaiton);
        let name = notificaiton.sender.name.first + ' ' + notificaiton.sender.name.middle + ' ' + notificaiton.sender.name.last;
        this.messageService.add({ severity: 'info', summary: name, detail: notificaiton.message });
      }
    });

    //Update Event Listner
    // this.socket.on('update-event', (type: string) => {
    //   if (type == 'OU') {
    //     this.orgUnitService.getLatesOrgs();
    //   }
    // });
  }
}
